//bootstrap widths so we can use them in our JS code
export const SM_SCREEN = 576;
export const MD_SCREEN = 768;
export const LG_SCREEN = 992;
export const XL_SCREEN = 1200;
